import {
  baseRequestWithAxiosResponse,
  baseRequestWithHeaders,
} from './base-request';

export const getPendingOnboardingRequests = (filters, appliedOrderBy) => {
  const urlQuery = new URLSearchParams(filters).toString();

  const url = `doctors/pending-onboardings`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, {
    ...filters,
    orderBy: appliedOrderBy,
  });
};

export const getPendingOnboardingRequestsCount = (filters, appliedOrderBy) => {

  const url = `doctors/pending-onboardings-count`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, {
    ...filters,
    orderBy: appliedOrderBy,
  });
};

export const claimOnboarding = (requestId) => {
  return baseRequestWithAxiosResponse(
    'operator/claim/onboarding',
    'POST',
    null,
    { requestId }
  )
    .then((response) => {
      console.log(response);
      if (response.data.message === 'success')
        return Promise.resolve(response.data);
      else return Promise.reject(response.data.message);
    })
    .catch((err) => {
      throw err;
    });
};

export function getAllOperators() {
  return baseRequestWithAxiosResponse('operator/all', 'GET')
    .then((response) => {
      console.log(response);
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      throw err;
    });
}
